import { useState } from 'react';
import { BoardContainer } from './style';
import { Theme, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import replacer from '../../../utils/replacer';

type Iprop = {
  data: Record<string, string[]>;
  children: any;
};
export const CategoryBoard = ({ data, children }: Iprop) => {
  const [show, setShow] = useState(false);
  const md = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const itemObject = Object.keys(data);

  const navigate = useNavigate();

  // const go = (key: string) => {
  //   const new_sub = replacer(/\s+/g, '-', key)!.toLowerCase();
  //   navigate(new_sub);
  // };

  const search = (item: string) => {
    const new_sub = replacer(/\s+/g, '-', item)!.toLowerCase();
    navigate(`?item=${new_sub}`);
    setShow(false);
  };

  return (
    <>
      {md ? (
        children
      ) : (
        <BoardContainer onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
          {children}
          {show && (
            <div className="board">
              {itemObject.map(key => {
                return (
                  <>
                    <ul key={key}>
                      <li className="header">{key}</li>
                      {data[key].map((item, index) => (
                        <li onClick={() => search(item)} key={index}>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </>
                );
              })}
            </div>
          )}
        </BoardContainer>
      )}
    </>
  );
};
